import React, { useEffect, useState } from 'react';
import { formatCurrencyInput, parseCurrencyInput } from '../../utils/format';

interface AmountInputProps {
  value?: number | null;
  onChange: (value: number | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
}

/** Campo de importe en formato español: se edita libre y se formatea al salir. */
const AmountInput: React.FC<AmountInputProps> = ({ value, onChange, disabled, placeholder, className, id }) => {
  const [text, setText] = useState(formatCurrencyInput(value));
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (!focused) setText(formatCurrencyInput(value));
  }, [value, focused]);

  return (
    <input
      id={id}
      type="text"
      inputMode="decimal"
      className={className}
      value={text}
      disabled={disabled}
      placeholder={placeholder}
      onFocus={() => setFocused(true)}
      onChange={(e) => {
        setText(e.target.value);
        onChange(parseCurrencyInput(e.target.value));
      }}
      onBlur={() => {
        setFocused(false);
        setText(formatCurrencyInput(parseCurrencyInput(text)));
      }}
    />
  );
};

export default AmountInput;
